<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">Aspirantes</h1>
        <div class="mb-6 flex  items-center">
        </div>
        
        <!-- <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="px-6 pt-6 pb-4">Nombre</th>
                    <th class="px-6 pt-6 pb-4">Apellido</th>
                </tr>
                <tr v-for="aspirante in aspirantes" :key="aspirante.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('aspirantes.edit', aspirante.id)">
                            {{ aspirante.nombre }}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route('aspirantes.edit', aspirante.id)" tabindex="-1">
                            {{ aspirante.apellido }}
                        </inertia-link>
                    </td>
                </tr>
            </table>
        </div> -->
        <el-table
        :data="aspirantes"
        stripe
        style="width: 100%"
        height="600"
        >
            
            <el-table-column
            prop="nombre"
            label="Nombre"
            width="150">
            </el-table-column>

            <el-table-column
            prop="apellido"
            label="Apellido"
            width="150">
            </el-table-column>

            <el-table-column
            prop="tipo_documento"
            label="T. Documento"
            width="120">
            </el-table-column>

            <el-table-column
            prop="numero_documento"
            label="Documento"
            width="150">
            </el-table-column>

            <el-table-column
            prop="edad"
            label="Edad"
            width="100">
            </el-table-column>

            <el-table-column
            prop="correo_electronico"
            label="Email">
            </el-table-column>

            <el-table-column
            prop="certificado_de_discapacidad"
            label="Cert. de discapacidad"
            align="center">
            </el-table-column>

            <el-table-column
            label="Acciones">
            <template slot-scope="scope">
                <el-link icon="el-icon-edit" :href="route('aspirantes.edit', scope.row.id)">Editar</el-link>
                <!-- <inertia-link class="btn-indigo" :href="route('aspirantes.edit', scope.row.id)">Editar</inertia-link> -->
            </template>
            </el-table-column>

        </el-table>
      
    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
    metaInfo: { title: 'Aspirantes' },
    components: {
        Icon,
        Pagination,
        SearchFilter,
    },
    layout: Layout,
    props: {
        aspirantes: Array,
    },
    data() {
        return {
        }
    },

}
</script>
